<template>
    <el-form :model="rule" :rules="rules" ref="forms" class="demo-ruleForm" label-width="100px">
        <el-form-item label="名称" prop="name">
            <el-input placeholder="请输入名称" v-model="rule.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="国家" prop="countryId">
            <el-select v-model="rule.countryId">
                <el-option value="" label="请选择国家"></el-option>
                <el-option v-for="x in selectList" :key="x.id" :value="x.id" :label="x.name"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="描述" prop="desc">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入描述" v-model="rule.desc" clearable></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submit">提交</el-button>
            <el-button @click="block">返回</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    export default {
        data() {
            return {
                name: 'edit',
                selectList: [],
                rule: {
                    id: 0,
                    name:'',
                    desc: '',
                    countryId:''
                },
                rules: {
                    name: {required: true, message: '请输入名称'},
                    desc: {required: true, message: '请输入描述'},
                    countryId: {required: true, message: '请选择国家',trigger:'blur'},
                },
            }
        },
        async created() {
            this.$http.get('/manage/country/listAll').then(data=>{
                this.selectList = data['data']['data'];
            });
            if(this.$route.params.id) {
                if(this.$store.state.editInfo.length == 0) {
                    this.$router.push('/sim/yys');
                }else {
                    this.rule = this.$store.state.editInfo;
                    this.rule.countryId = this.$store.state.editInfo.country.id;
                }
            }
        },
        methods: {
            submit() {
                this.$refs['forms'].validate(valid => {
                    if(valid) {
                        if(this.rule.id == 0) {
                            delete this.rule.id;
                            this.$http.post('/manage/operator/add',this.rule).then(rs => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.push('/sim/yys');
                                }else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }else {
                            this.$http.post('/manage/operator/edit',this.rule).then(rs => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.push('/sim/yys');
                                }else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }
                    }
                });
            },
            block() {
                this.$router.push('/sim/yys');
            }
        }
    }
</script>